module.exports = __webpack_public_path__ + "img/toplogo.53575326.png";